module.exports = __webpack_public_path__ + "static/media/PM108.cc6031df.png";